import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getUpcomingLiveOverview = async () => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `productivity-host/schedule/upcoming`,
  });

  return data?.data;
};

export default getUpcomingLiveOverview;
